<template>
  <header class="text-dark-teal-600 z-[3] bg-light-pink-200 relative flex flex-col items-center justify-center h-auto border-b border-black text-center gap-20 px-8 pt-16 pb-20 md:pt-20 md:pb-24 lg:pt-28 lg:pb-36">
    <div class="flex flex-col max-w-screen-sm gap-8 lg:gap-10 lg:max-w-screen-md">
      <div class="text-xl md:text-2xl">{{ t('pages.features.hero.kicker') }}</div>
      <h1 class="text-5xl font-medium md:text-6xl md:leading-[0.9] lg:text-8xl">
        {{ t('pages.features.hero.titleLine1') }} <br />{{ t('pages.features.hero.titleLine2') }}
      </h1>
      <div class="text-xl md:text-2xl">
        <i18n-t keypath="pages.features.hero.body">
          <template #brand>
        <span class="font-serif">ommi.shop</span> 
          </template>
        </i18n-t>
      </div>
    </div>
    
    <div class="pointer-events-none absolute inset-0 overflow-visible z-10">
      <img class="absolute -left-16 top-0 h-32 w-32 lg:left-24 lg:top-32 lg:h-56 lg:w-56" :alt="t('pages.features.hero.illustrations.alt1')" src="/images/features/cool-svgrepo-com.svg">
      <img class="override hidden absolute top-1/2 -left-12 :h-56 w-56 lg:block" :alt="t('pages.features.hero.illustrations.alt2')" src="/images/features/cool-svgrepo-com.svg">
      <img class="absolute -left-24 bottom-0 h-32 w-32 lg:left-20 lg:-bottom-24 lg:h-56 lg:w-56" :alt="t('pages.features.hero.illustrations.alt3')" src="/images/features/cool-svgrepo-com.svg">
      <img class="absolute -right-24 bottom-0 h-32 w-32 lg:right-64 lg:-bottom-24 lg:h-48 lg:w-48" :alt="t('pages.features.hero.illustrations.alt4')" src="/images/features/cool-svgrepo-com.svg">
      <img class="override hidden absolute top-1/2 right-16 h-48 w-48 lg:block" :alt="t('pages.features.hero.illustrations.alt5')" src="/images/features/cool-svgrepo-com.svg">
      <img class="absolute -right-20 top-0 h-32 w-32 lg:right-32 lg:top-32 lg:h-48 lg:w-48" :alt="t('pages.features.hero.illustrations.alt6')" src="/images/features/cool-svgrepo-com.svg">
    </div>
  </header>
</template>

<script setup lang="ts">
import { useI18n } from '#imports'

const { t } = useI18n()
</script>
